import { pick } from "lodash-es"

const UTM_PARAMS_STORAGE_KEY = "camp-utm-params:1"

const UTM_PARAM_KEYS = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term"
]

export const storeUtmParams = () => {
  try {
    const params = new URLSearchParams(location.search)
    const utmParams = pick(Object.fromEntries(params), UTM_PARAM_KEYS)
    if (Object.keys(utmParams).length == 0) return
    window.localStorage.setItem(
      UTM_PARAMS_STORAGE_KEY,
      JSON.stringify(utmParams)
    )
  } catch (e) {
    console.error(e)
  }
}

export const getUtmParams = () => {
  let utmParams = {}
  try {
    const data = window.localStorage.getItem(UTM_PARAMS_STORAGE_KEY) || "{}"
    utmParams = JSON.parse(data)
  } catch (e) {
    console.error(e)
  }
  return utmParams
}
